module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-dropdown', {
    attrs: {
      "infos": _vm.infos,
      "defaultOption": _vm.limit
    },
    on: {
      "change": _vm.changePage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7d14508","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/SortNumeric.vue
// module id = 3429
// module chunks = 0